import DeleteDialog from 'shell/components/shared/delete-dialog';
import { Fragment, useState, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import TableCard from 'civil-status/components/document-registry/table';
import { DocumentRegistryListCrumbs } from 'civil-status/constants/document-registry-breadcrumb';
import ListHeader from 'shell/components/shared/list-header';
import { generatePath, useNavigate } from 'react-router-dom';
import { DocumentRegistryItemVM } from 'civil-status/view-models/document-registry-list';
import { DocumentRegistry } from 'shell/models/document-registry';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { HttpResponseList } from 'shell/models/http-response';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { authsRowDocumentRegistry } from 'civil-status/components/document-registry/table/table-row';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';

const DocumentRegistryList = (): React.ReactElement => {
  const [elementToDelete, setElementToDelete] = useState<null | DocumentRegistryItemVM>(null);
  const navigate = useNavigate();

  const [series, getSeries] = useHttpFetch<
    HttpResponseList<DocumentRegistry>,
    Array<DocumentRegistryItemVM>
  >(`${__CIVIL_STATUS_API_URL__}/registro-atto`, {
    onBootstrap: true,
    options: {
      method: 'GET',
    },
    transformer: (response) =>
      (response?.data?.payload?.list || []).map((item) => ({
        code: item.key?.codiceRegistro || '',
        number: item.key?.codiceRegistro || '',
        description: item.registro || '',
      })),
  });

  const seriesData = (series.data as Array<DocumentRegistryItemVM>) || [];

  const deleteItem = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/registro-atto/cancella-registro-atto`,
    {
      options: {
        method: 'DELETE',
      },
    }
  );

  const clearToDelete = useCallback(() => setElementToDelete(null), [setElementToDelete]);

  const onConfirm = useCallback((): void => {
    if (elementToDelete) {
      (deleteItem({ url: `/${elementToDelete.code}` }) as ResponsePromise<void>).then(() => {
        getSeries();
        setElementToDelete(null);
      });
    }
  }, [elementToDelete, deleteItem, getSeries, setElementToDelete]);

  const auths = useActionAuthorization(authsRowDocumentRegistry);

  return (
    <Fragment>
      <Breadcrumbs items={DocumentRegistryListCrumbs} />
      <ListHeader
        addBtnAriaLabel="Aggiungi nuovo registro"
        addBtnLabel="Aggiungi nuovo registro"
        canAdd={auths.add}
        onAddBtnClick={() => {
          navigate('/stato-civile/registri/nuovo');
        }}
        title="Lista Numeri Registro"
      />
      <div className="pmi-mt-2">
        <TableCard
          items={seriesData}
          onTrashPress={(card) => setElementToDelete(card)}
          onEditPress={(item) =>
            navigate(generatePath(`/stato-civile/registri/modifica/:id`, { id: item.number }))
          }
          onVisibilityPress={(item) =>
            navigate(generatePath(`/stato-civile/registri/dettaglio/:id`, { id: item.number }))
          }
        />
      </div>
      {Boolean(elementToDelete) ? (
        <DeleteDialog
          isOpen={Boolean(elementToDelete)}
          onAbort={clearToDelete}
          onClose={clearToDelete}
          onConfirm={onConfirm}
        />
      ) : null}
    </Fragment>
  );
};

DocumentRegistryList.displayName = 'Document Registry list page component';

export default DocumentRegistryList;
